import React from 'react';
import { Award, Shield, CheckCircle, Users } from 'lucide-react';

const Certifications = () => {
  return (
    <section id="certifications" className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-blue-700 font-semibold text-sm uppercase tracking-wider">Qualifications</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mt-4 mb-6">
            Des certifications reconnues internationalement
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Notre équipe possède les plus hautes qualifications dans le domaine des travaux sur cordes
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-blue-100 hover:border-blue-300 transition-colors">
            <div className="flex items-start space-x-4">
              <div className="bg-blue-700 p-4 rounded-xl">
                <Award className="text-white" size={32} />
              </div>
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-slate-900 mb-3">CQP Cordiste</h3>
                <p className="text-slate-600 leading-relaxed">
                  Certificat de Qualification Professionnelle délivré par la branche professionnelle française. 
                  Cette certification garantit une maîtrise complète des techniques de travaux sur cordes et des normes de sécurité.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-blue-100 hover:border-blue-300 transition-colors">
            <div className="flex items-start space-x-4">
              <div className="bg-blue-700 p-4 rounded-xl">
                <Shield className="text-white" size={32} />
              </div>
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-slate-900 mb-3">IRATA International</h3>
                <p className="text-slate-600 leading-relaxed">
                  Certification internationale reconnue mondialement pour les travaux d'accès difficile. 
                  IRATA établit les standards les plus élevés en matière de sécurité et de professionnalisme.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-blue-700 to-blue-900 rounded-2xl p-12 text-white">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <CheckCircle className="mx-auto mb-4" size={40} />
              <h4 className="text-2xl font-bold mb-2">100%</h4>
              <p className="text-blue-100">Conformité sécurité</p>
            </div>
            <div>
              <Users className="mx-auto mb-4" size={40} />
              <h4 className="text-2xl font-bold mb-2">Équipe qualifiée</h4>
              <p className="text-blue-100">Cordistes certifiés</p>
            </div>
            <div>
              <Award className="mx-auto mb-4" size={40} />
              <h4 className="text-2xl font-bold mb-2">10 ans</h4>
              <p className="text-blue-100">Garantie maçonnerie</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Certifications;